import React, { Fragment } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import Button from 'components/theme/Button'
import { stepperIncrease } from 'actions/view'
import { withRouter } from 'react-router-dom'
import { Hidden } from '@material-ui/core'

export default withRouter(
  connect(
    (state, { stepsLength }) => ({
      onLastStep: state.view.stepper === stepsLength - 1,
    }),
    (dispatch) => bindActionCreators({ stepperIncrease }, dispatch),
  )(
    ({
      onLastStep,
      stepperIncrease,
      create,
      update,
      location,
    }) => {
      const locationSlice =
        location &&
        location.pathname &&
        location.pathname.slice &&
        location.pathname.slice(-4)

      const newEntity = locationSlice === '/new' || locationSlice === 'new/'

      const button = (size, fontSize) => (
        <Button
          style={fontSize ? { fontSize } : null}
          disabled={onLastStep}
          variant="contained"
          color="secondary"
          onClick={() =>
            onLastStep && (create || update)
              ? newEntity
                ? create()
                : update()
              : stepperIncrease()
          }
        >
          {onLastStep && (create || update) ? 'Create' : 'Next'}
        </Button>
      )

      return (
        <Fragment>
          <Hidden smDown>{button('medium')}</Hidden>
          <Hidden mdUp>{button('small', 8)}</Hidden>
        </Fragment>
      )
    },
  ),
)
